import { render, staticRenderFns } from "./OrderRegulationCheckField.vue?vue&type=template&id=77d244a6&scoped=true&"
import script from "./OrderRegulationCheckField.vue?vue&type=script&lang=js&"
export * from "./OrderRegulationCheckField.vue?vue&type=script&lang=js&"
import style0 from "./OrderRegulationCheckField.vue?vue&type=style&index=0&id=77d244a6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d244a6",
  null
  
)

export default component.exports